import _toConsumableArray from "/builds/raisin-global/raisin-us/savebetter/savebetter/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { isError, computeRawError } from '../error/error';
import { mergeObservables, Observable } from '../../tools/observable';
import { ConsoleApiName, globalConsole } from '../../tools/display';
import { callMonitored } from '../../tools/monitor';
import { sanitize } from '../../tools/serialisation/sanitize';
import { jsonStringify } from '../../tools/serialisation/jsonStringify';
import { ErrorSource } from '../error/error.types';
import { computeStackTrace } from '../../tools/stackTrace/computeStackTrace';
import { createHandlingStack, formatErrorMessage } from '../../tools/stackTrace/handlingStack';
import { clocksNow } from '../../tools/utils/timeUtils';
var consoleObservablesByApi = {};
export function initConsoleObservable(apis) {
  var consoleObservables = apis.map(function (api) {
    if (!consoleObservablesByApi[api]) {
      consoleObservablesByApi[api] = createConsoleObservable(api); // we are sure that the observable created for this api will yield the expected ConsoleLog type
    }

    return consoleObservablesByApi[api];
  });
  return mergeObservables.apply(void 0, _toConsumableArray(consoleObservables));
}
export function resetConsoleObservable() {
  consoleObservablesByApi = {};
}

function createConsoleObservable(api) {
  return new Observable(function (observable) {
    var originalConsoleApi = globalConsole[api];

    globalConsole[api] = function () {
      for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
        params[_key] = arguments[_key];
      }

      originalConsoleApi.apply(console, params);
      var handlingStack = createHandlingStack('console error');
      callMonitored(function () {
        observable.notify(buildConsoleLog(params, api, handlingStack));
      });
    };

    return function () {
      globalConsole[api] = originalConsoleApi;
    };
  });
}

function buildConsoleLog(params, api, handlingStack) {
  var message = params.map(function (param) {
    return formatConsoleParameters(param);
  }).join(' ');

  if (api === ConsoleApiName.error) {
    var firstErrorParam = params.find(isError);
    var rawError = computeRawError({
      originalError: firstErrorParam,
      handlingStack: handlingStack,
      startClocks: clocksNow(),
      source: ErrorSource.CONSOLE,
      handling: "handled"
      /* ErrorHandling.HANDLED */
      ,
      nonErrorPrefix: "Provided"
      /* NonErrorPrefix.PROVIDED */
      ,
      // if no good stack is computed from the error, let's not use the fallback stack message
      // advising the user to use an instance of Error, as console.error is commonly used without an
      // Error instance.
      useFallbackStack: false
    }); // Use the full log message as the error message instead of just the error instance message.

    rawError.message = message;
    return {
      api: api,
      message: message,
      handlingStack: handlingStack,
      error: rawError
    };
  }

  return {
    api: api,
    message: message,
    error: undefined,
    handlingStack: handlingStack
  };
}

function formatConsoleParameters(param) {
  if (typeof param === 'string') {
    return sanitize(param);
  }

  if (isError(param)) {
    return formatErrorMessage(computeStackTrace(param));
  }

  return jsonStringify(sanitize(param), undefined, 2);
}